require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./locations-learn-to-code-in-seattle.json") })
        }
      }, "path---locations-learn-to-code-in-seattle");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---locations-learn-to-code-in-seattle!./.cache/json/locations-learn-to-code-in-seattle.json
// module id = 1170
// module chunks = 231608221292675